import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';


import {
    // Navigation
    MatMenuModule
} from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AppSettings, DataService, FG_APP_CONSTANTS, FgAppConstants, FgMenuService } from 'fg-library';
import { animate, style, transition, trigger } from '@angular/animations';
@Component({
    selector: 'fg-mega-menu',
    templateUrl: './fg-mega-menu.html',
    styleUrls: ['./fg-mega-menu.scss'],
    animations: [
        trigger('fadeSlideIn', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-60px) scaleY(0.95)' }),
                animate('700ms cubic-bezier(0.33, 1, 0.68, 1)', style({ opacity: 1, transform: 'translateY(0) scaleY(1)' }))
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-20px) scaleY(0.98)' }))
            ])
        ])
    ],
    standalone: false
})
export class MegaMenuItemComponent {

    @Input() items: any;

    @Input() localConfig: any;
    @ViewChild('childMenu', { static: true }) public childMenu: any;
    topNavSettings;
  @Input() myapps: any[] = [];
  @Output() menuItemSelected = new EventEmitter<{ pageId: string, name: string }>();

  apps: any[] = [];
  showMegaMenu = false;

    @ViewChild('menuContainer', { static: false }) menuContainer!: ElementRef;

    constructor(public router: Router, private fgMenuService: FgMenuService, public dataService: DataService, private route: ActivatedRoute,   @Inject(FG_APP_CONSTANTS) public fgAppConstant: FgAppConstants,) {
        this.topNavSettings = AppSettings.topNav;
    }

  ngOnInit() {
this.myapps = this.myapps
  .filter(app => ['Web', 'Universal'].includes(app.deviceChannel))
  .map(app => {
    const allGroups = app.menuGroup || [];

    // 1. Separate actual groups vs leaf entries
    const actualGroups = allGroups.filter(group => group.menuGroup === true);
    const leafItems = allGroups
      .filter(group => group.menuGroup === false)
      .filter(group => !!group.pageId); // ✅ only keep those with pageId

    // 2. Wrap valid leaf items into "Menus" group
    const newMenuGroups = [...actualGroups];

    if (leafItems.length > 0) {
      newMenuGroups.unshift({
        name: 'Menus',
        menuGroup: true,
        menuItem: leafItems,
        appId: app.appId
      });
    }

    return {
      ...app,
      menuGroup: newMenuGroups
    };
  });




      console.log(this.myapps);
  }


  toggleMegaMenu() {
    this.showMegaMenu = !this.showMegaMenu;
  }
// meny size adjustments
estimateItemWidth(item: any): number {
  const tempEl = document.createElement('div');
  tempEl.style.position = 'absolute';
  tempEl.style.visibility = 'hidden';
  tempEl.style.whiteSpace = 'nowrap';
  tempEl.style.fontSize = '14px'; // match your menu font

  tempEl.innerText = item.name;
  document.body.appendChild(tempEl);

  const width = tempEl.offsetWidth + 32; // add padding/margin
  tempEl.remove();

  return width;
}




selectedPage:any;
    public toggleActive(menu: any,selectedapp:any ,index: any): void { 

        if (menu.children && menu.children.length > 0) return;
        var app = { "appId": selectedapp || this.fgMenuService.appId };

        if ( this.fgAppConstant["AppUtills"].isNotNull( this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId))) {
            var pageUrl =  this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId);

            this.router.navigate([`${pageUrl}`]);
        } else {
            let detailParams: NavigationExtras = {
                queryParams: {
                    menu : menu
                }
            };
            var pageUrl: any =  this.fgAppConstant["StudioUtills"].getPageUrl(menu, app, this.router.url);
            this.router.navigate([`${pageUrl}`], {  state: { id: detailParams } });
        }
        this.selectedPage = menu;
        this.menuItemSelected.emit({ pageId: menu.pageId, name: menu.name });
    }

    public getNamedPageUrl(menu: any, index: any) {
        let pageUrl = null;
        if (menu.children && menu.children.length > 0) return;
        var app = { "appId": this.fgMenuService.appId };

        if ( this.fgAppConstant["AppUtills"].isNotNull( this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId))) {
            pageUrl =  this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId);
            // this.router.navigate([`${pageUrl}`]);
        } else {
            pageUrl =  this.fgAppConstant["StudioUtills"].getPageUrl(menu, app, this.router.url);
            // this.router.navigate([`${pageUrl}`]);
        }
        return pageUrl;
    }

        isActiveMenu(pageId: any) {
        return this.router.url.includes(pageId) ? true : false;
    }


    selectedAppIndex: number = 0;
wordCloudWords:any;
selectApp(index: number) {
  this.selectedAppIndex = index;
  let realWordsFromApp = this.extractWordCloudFromApp(this.myapps[index]);

  this.wordCloudWords = [
  ...(realWordsFromApp || []),
  ...defaultWordCloudWords.slice(0, 20 - (realWordsFromApp?.length || 0))
];

}

get selectedApp() {
  return this.myapps?.[this.selectedAppIndex];
}

getAvatarInitials(name: string): string {
  if (!name) return '';
  const words = name.trim().split(' ');
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

getAppName(){

  return this.getFirstLeafMenuName(this.fgMenuService.appId)

}

 getFirstLeafMenuName( appId: string): string | null {
  const app = this.myapps.find(app => app.appId === appId);
  if (!app || !Array.isArray(app.menuGroup)) return null;

  // Look for the first entry where menuGroup === false

  return app.name;

}
// const words = extractWordCloudFromApp(this.selectedApp);
// console.log(words);
 
extractWordCloudFromApp(app: any): string[] {

  const textFields: string[] = [];

  if (app.name) textFields.push(app.name);
  if (app.title) textFields.push(app.title);
  if (app.subTitle) textFields.push(app.subTitle);

  (app.menuGroup || []).forEach(group => {
    if (group.name) textFields.push(group.name);
    (group.menuItem || []).forEach(item => {
      if (item.name) textFields.push(item.name);
    });
  });

  return Array.from(new Set(
    textFields
      .join(' ')
      .replace(/\n/g, ' ')
      .split(/\s+/)
      .map(w => w.trim().replace(/[^a-zA-Z0-9]/g, ''))
      .filter(w => w.length > 2)
  ));
}

getWordPosition(i: number, total: number): any {
  const radius = 45;
  const angle = Math.random() * 2 * Math.PI;
  const r = Math.sqrt(Math.random()) * radius;

  const x = 50 + r * Math.cos(angle);
  const y = 50 + r * Math.sin(angle);

  return {
    top: `${y}%`,
    left: `${x}%`,
    position: 'absolute',
    fontSize: `${12 + (i % 5) * 2}px`,
    color: `hsl(${(i * 137.5) % 360}, 70%, 50%)`,
    whiteSpace: 'nowrap',
    maxWidth: '80px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
}

}
const defaultWordCloudWords = [
  'Liquidity',
  'Receivables',
  'Payments',
  'Collections',
  'Credit',
  'Trade',
  'Treasury',
  'Risk',
  'Compliance',
  'Onboarding',
  'Mandates',
  'Loans',
  'Assets',
  'Cashflow',
  'Deposits',
  'Reconciliation',
  'KYC',
  'Authorization',
  'Workflow',
  'Forecasting'
];